(ns hai.library.prompts.table
  "Prompts table"
  (:require
   [hai-model.model :as model]
   [hai.sharing.components :as sharing.components]
   hai.library.prompts.api
   [hai.ui.components.card :as card]
   [hai.ui.components.collection.bulk-actions :as bulk-actions]
   [hai.ui.components.collection.filters :as filters]
   [hai.ui.components.collection.form :as col.form]
   [hai.ui.components.collection.table :as collection]
   [hai.ui.components.collection.views.cards :as cards]
   [hai.ui.components.new-design.button :as button]
   [hai.ui.icons :as icons]
   [hai.ui.rf-sugar :refer [>e]]
   [hai.web-app.layout :as layout]
   [humbleai.belt.dom :as dom]
   [malli.util :as mu]))

(def PromptEditSchema
  (mu/select-keys model/Prompt [:ai-prompt/uuid :ai-prompt/title :ai-prompt/content :ai-prompt/magic-fill?]))

(defn table
  []
  [collection/component
   {:id ::table
    :schema PromptEditSchema
    :query [{:prompts/table
             [{:collection/items
               [:ai-prompt/uuid
                :ai-prompt/title
                :ai-prompt/content
                :ai-prompt/magic-fill?
                :user.entity/permissions
                sharing.components/shared-with-query]}]}]
    :paginate? true
    :update-mutation 'ai-prompt/update
    ;; TODO default card render
    :card (fn [collection {prompt :form/current-value :as item}]
            [card/card
             {:on-click (fn [e]
                          (when-not (dom/bubbled-event? e)
                            (>e [:routing/navigate [:ai-prompts/edit prompt]])))}
             [cards/card-select-checkbox collection item]
             [cards/column-render collection item]])
    :columns [{:header "Title"
               :attr   :ai-prompt/title
               :field  (col.form/link-input :ai-prompts/edit)
               :filter (filters/text-search {:placeholder "Title..."})}
              {:header "Content"
               :attr   :ai-prompt/content
               :field  col.form/input
               :filter (filters/text-search {:placeholder "Content..."})}
              {:header "Magic Fill"
               :attr   :ai-prompt/magic-fill?
               :field  col.form/toggle}
              sharing.components/shared-with-column]
    :bulk-actions [{:title    "Delete"
                    :mutation 'ai-prompt/delete
                    :alert    {:content (fn [{:table/keys [selected] :as table} action]
                                          [bulk-actions/confirm-dialog
                                           {:table  table
                                            :action action}
                                           [bulk-actions/title "Confirm Deletion of Connections"]
                                           [bulk-actions/description "Are you sure you want to delete the following connections?"]
                                           (into [:ul]
                                                 (map (fn [{:ai-prompt/keys [title]}]
                                                        [:li [:strong title]]))
                                                 selected)])}}]}])

(defn page
  [_]
  [layout/page
   [layout/breadcrumbs]
   [layout/heading]
   [layout/lead*
    [layout/lead
     "Save and share templates and prompts your team can reuse — without rewriting the same thing twice."]
    [:div.buttons
     [button/dark-small
      {:on-click (fn [_] (>e [:routing/navigate [:ai-prompt/create]]))
       :text     "Create a template"
       :icon     [icons/plus]}]]]
   [layout/content
    [table]]])
